import { ComponentType } from '@angular/cdk/portal';
import { AddDeliveryAddressComponent } from './add-delivery-address/add-delivery-address.component';
import { AttachmentDeadlineDialogComponent } from './attachment-deadline-dialog/attachment-deadline-dialog.component';
import { AttachmentNoDeadlineDialogComponent } from './attachment-no-deadline-dialog/attachment-no-deadline-dialog.component';
import { CaseAssignedToBailiffDialogComponent } from './case-assigned-to-bailiff-dialog/case-assigned-to-bailiff-dialog.component';
import { ClientUploadContractDialogComponent } from './client-upload-contract-dialog/client-upload-contract-dialog.component';
import { CloseCaseComponent } from './close-case/close-case.component';
import { DebtorIndDataDialogComponent } from './debtor-ind-data-dialog/debtor-ind-data-dialog.component';
import { DiscardCaseComponent } from './discard-case/discard-case.component';
import { FullPaymentStatementComponent } from './full-payment-statement/full-payment-statement.component';
import { GenerateAttorneyDataDialogComponent } from './generate-attorney-data-dialog/generate-attorney-data-dialog.component';
import { InstallmentComponent } from './installment/installment.component';
import { ManualPaymentComponent } from './manual-payment/manual-payment.component';
import { MissedInstallmentReportComponent } from './missed-installment-report/missed-installment-report.component';
import { MissingDataGeneralComponent } from './missing-data-general/missing-data-general.component';
import { NoAttachmentNoDeadlineDialogComponent } from './no-attachment-no-deadline-dialog/no-attachment-no-deadline-dialog.component';
import { OverwriteStateDialogComponent } from './overwrite-state-dialog/overwrite-state-dialog.component';
import { RealEstateExecutionComponent } from './real-estate-execution/real-estate-execution.component';
import { StartExecutionDialogComponent } from './start-execution-dialog/start-execution-dialog.component';

export function getDialogComponent(name: string): ComponentType<any> {
  switch (name) {
    case 'ATTORNEY-ATTACHMENT_DEADLINE': return AttachmentDeadlineDialogComponent;
    case 'ATTORNEY-ATTACHMENT_NO_DEADLINE': return AttachmentNoDeadlineDialogComponent;
    case 'ATTORNEY-NO_ATTACHMENT_NO_DEADLINE': return NoAttachmentNoDeadlineDialogComponent;
    case 'CASE-ASSIGNED-TO-BAILIFF': return CaseAssignedToBailiffDialogComponent;
    case 'CLIENT-UPLOAD-CONTRACT': return ClientUploadContractDialogComponent;
    case 'DEBTOR-IND-DATA': return DebtorIndDataDialogComponent;
    case 'DIALOG_23-MISSED_INSTALLMENT': return MissedInstallmentReportComponent;
    case 'DIALOG_24-NEW_ADDRESS': return AddDeliveryAddressComponent;
    case 'DIALOG_26-DEBTOR_FULL_PAYMENT_APPROVE': return FullPaymentStatementComponent;
    case 'DIALOG_27-SOFT_PP': return InstallmentComponent;
    case 'DIALOG_4-ACTION-DISCARD': DiscardCaseComponent;
    case 'DIALOG_5-ACTION_CANCEL': return CloseCaseComponent;
    case 'DIALOG_8-PAYMENT-STAGE': return ManualPaymentComponent;
    case 'DIALOG_9-PAYMENT-STAGE-WHILE-AT-ATTORNEY': return ManualPaymentComponent;
    case 'GENERATE-ATTORNEY-DATA': return GenerateAttorneyDataDialogComponent;
    case 'HIANYPOTLAS-GENERAL': return MissingDataGeneralComponent;
    case 'OVERWRITE_STATE': return OverwriteStateDialogComponent;
    case 'START-HARD_2': return StartExecutionDialogComponent;
    case 'SUBMISSION_REGISTRATION_OF_RIGHT_OF_ENFORCEMENT': return RealEstateExecutionComponent;
    default: throw new Error('Unknown component');
  };
}
